import { render, staticRenderFns } from "./SpecialBrainMachine.vue?vue&type=template&id=cc447746&scoped=true"
import script from "./SpecialBrainMachine.vue?vue&type=script&lang=js"
export * from "./SpecialBrainMachine.vue?vue&type=script&lang=js"
import style0 from "./SpecialBrainMachine.vue?vue&type=style&index=0&id=cc447746&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc447746",
  null
  
)

export default component.exports